import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/hand-spock': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M21.1 381.8L150.2 503.3A32-32 0 0 1 172.1 512H409.7C423.9 512 436.4 502.7 440.4 489.1L472.2 381.8A116-116 0 0 1 477 348.8V312C477 307.9 477.5 303.9 478.4 299.9L510.1 166.5C520.2 124.1 487.8 83.8 444.6 84 440.5 59.1 422.1 36.8 394.8 30 358.9 21 322.5 42.7 313.5 78.8L296.6 184 274.9 52C266.6 15.9 230.6-6.6 194.6 1.7 165 8.5 144.5 34.1 142.7 63 100.1 63.8 69.3 103.6 78.7 144.9L109.7 281.4C82.5 258.8 42.4 261.4 18.2 287.1-7.2 314-5.9 356.4 21.1 381.8zM53.2 320L53.2 320C60.4 312.3 72.4 312 80 319.2L133 369.1C143.2 378.6 160 371.4 160 357.4V287.9C160 286.7 159.9 285.5 159.6 284.4L125.5 134.2C119.9 109.6 157 101.3 162.5 125.8L192.9 259.5A16-16 0 0 1 208.5 272H217.1C227.4 272 235 262.4 232.7 252.4L191.1 71.3C185.5 46.8 222.5 38.2 228.1 62.8L273.4 259.6A16-16 0 0 1 289 272H302.2A16-16 0 0 1 317.7 259.9L360.1 90.4C366.2 66 403 75.2 396.9 99.6L358.8 252.1C356.3 262.2 363.9 272 374.3 272H384A16-16 0 0 1 399.6 259.7L426.5 146.6C432.3 122.2 469.3 130.9 463.5 155.4L431.7 288.8A100.1-100.1 0 0 1 429 312V348.8C429 355.4 428.1 361.9 426.2 368.1L397.8 464H178.5L54 346.8C46.3 339.7 46 327.6 53.2 320z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/hand-spock.js
// module id = olzQ
// module chunks = 144